<template>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg h-auto flex flex-col items-center justify-center w-full p-6 relative"
  >
    <div
      class="bg-white dark:bg-gray-800 rounded-xl max-w-4xl w-full landscape:p-6 portrait:py-4"
    >
      <template v-if="loading">
        <div
          class="w-full flex flex-col justify-center items-center h-12 mt-6 mb-16"
        >
          <LoadingComponent /></div></template
      ><template v-else>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div
            v-for="plan in plans"
            :key="plan.id"
            :class="[
              'border rounded-xl overflow-hidden transition hover:shadow-lg hover:-translate-y-1 relative',
              plan.type === 'Pro'
                ? 'border-2 border-main-500 dark:border-sub-500'
                : '',
            ]"
          >
            <!-- RECOMMENDED badge for Pro -->
            <div
              v-if="plan.type === 'Pro'"
              class="absolute top-2 right-2 bg-main-500 dark:bg-sub-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full z-10 shadow"
              style="pointer-events: none"
            >
              RECOMMENDED
            </div>
            <div
              :class="[
                plan.type === 'Pro'
                  ? 'bg-main-50 dark:bg-sub-900/20'
                  : 'bg-gray-100 dark:bg-gray-700',
                'p-6 text-center',
              ]"
            >
              <h4 class="text-lg font-bold dark:text-gray-200">
                {{ plan.type }}
              </h4>
              <p
                :class="
                  plan.type === 'Pro'
                    ? 'text-main-600 dark:text-sub-300 text-sm mt-1'
                    : 'text-gray-500 dark:text-gray-400 text-sm mt-1'
                "
              >
                {{ plan.description }}
              </p>
              <div class="mt-6">
                <span class="text-4xl font-bold dark:text-gray-200"
                  >₦{{ plan.price.toLocaleString() }}</span
                >
                <span class="text-gray-500 dark:text-gray-400">/month</span>
              </div>
              <button
                @click="selectPlan(plan.id)"
                :class="
                  plan.type === 'Pro'
                    ? 'mt-6 w-full bg-main-500 hover:bg-main-600 text-white py-2 px-4 rounded-lg transition dark:bg-sub-700 dark:hover:bg-sub-900'
                    : 'mt-6 w-full bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-4 rounded-lg transition dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-gray-200'
                "
              >
                View Plan
              </button>
            </div>
            <div
              :class="
                plan.type === 'Pro'
                  ? 'p-6 border-t dark:border-sub-700'
                  : 'p-6 border-t dark:border-gray-700'
              "
            >
              <ul class="space-y-3">
                <li
                  v-for="feature in plan.features"
                  :key="feature"
                  class="flex items-center gap-2 text-sm dark:text-gray-300"
                >
                  <i class="fas fa-check text-green-500"></i>
                  <span>{{ feature }}</span>
                </li>
                <template v-if="plan.nofeatures && plan.nofeatures.length">
                  <li
                    v-for="nofeature in plan.nofeatures"
                    :key="nofeature"
                    class="flex items-center gap-2 text-sm text-gray-400"
                  >
                    <i class="fas fa-times text-red-400"></i>
                    <span>{{ nofeature }}</span>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div></template
      >

      <div class="mt-8 text-center text-sm text-gray-500 dark:text-sub-200">
        <p>
          Need a custom plan?
          <a
            href="#"
            class="text-main-500 hover:underline dark:text-sub-500 dark:hover:underline"
            >Contact sales</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewPlansComponent",
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    plans() {
      return this.$store.getters.servicePlans || [];
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("fetchServicePlans");
    this.loading = false;
  },
  methods: {
    selectPlan(plan) {
      this.$emit("plan-selected", plan);
      this.$emit("close");
    },
  },
};
</script>
